import React from "react";
import { Card, Dimmer, Loader } from "semantic-ui-react";
import { mapExistingSortboxItemsFromAllSortboxItems } from "../../lib/aframeboxlookup/UtilMethods";
import BoxItem from "../BoxItem/BoxItem";
import "./BoxItemList.css";

const BoxItemList = ({
  bagClasses = {},
  boxItems,
  isLoading,
  skuIsMissingCallback,
  skuInputCallback,
  isSingle,
  isWaitingForBox,
  aframe,
  skuChannels,
  isPaused,
  isAuto,
  isUrgent,
  showProgress = true,
  isRxMode = false,
  alwaysShowMissing = false,
  currentRXSortBoxID = -1,
  dynamicSkuChannels = null,
  allSortBoxItems = boxItems,
}) => {
  console.log(skuChannels);
  const getChannelsForItem = (channels, skuID) => {
    const skuChannels = channels[skuID];

    if (skuChannels && skuChannels.length) {
      return skuChannels;
    }
    return null;
  };

  let itemsPerRow;
  let items = boxItems.length;

  if (items <= 12) {
    itemsPerRow = 4;
  } else if (items <= 15) {
    itemsPerRow = 5;
  } else if (items <= 24) {
    itemsPerRow = 6;
  } else {
    itemsPerRow = 7;
  }

  return (
    <div className={"ArticlesDiv " + (isWaitingForBox ? "waiting" : "")}>
      <Dimmer active={isLoading} inverted>
        <Loader size="big" />
      </Dimmer>
      <Card.Group
        itemsPerRow={itemsPerRow}
        className={`CardGroupBottomMargin${isSingle || boxItems.length === 1 ? " single" : ""}`}
      >
        {mapExistingSortboxItemsFromAllSortboxItems(allSortBoxItems, boxItems).map((oi, i) => (
          <BoxItem
            rxBagClass={bagClasses.hasOwnProperty(oi.boxID) ? bagClasses[oi.boxID] : ""}
            aframe={aframe}
            skuChannels={aframe ? getChannelsForItem(skuChannels, oi.skuID) : null}
            dynamicSkuChannels={
              aframe && dynamicSkuChannels ? getChannelsForItem(dynamicSkuChannels, oi.skuID) : null
            }
            key={i}
            reservedQuantity={oi.reservedQuantity}
            verifiedQuantity={oi.verifiedQuantity}
            missingQuantity={oi.missingQuantity}
            partialQuantity={oi.partialQuantity}
            imageSrc={oi.imageURL}
            skuID={oi.skuID}
            shelfNumber={oi.shelfNumber}
            skuIsMissingCallback={skuIsMissingCallback}
            skuInputCallback={skuInputCallback}
            name={
              oi.isRx ? (
                <div>
                  {oi.name}
                  <br />
                  {oi.prescriptionName}
                  <br />
                  {oi.prescriptionPno}
                </div>
              ) : (
                oi.name
              )
            }
            isSingle={isSingle}
            isRx={oi.isRx}
            isPaused={isPaused}
            isAuto={isAuto}
            isUrgent={isUrgent}
            isBig={allSortBoxItems.length === 1}
            prefilled={oi.prefilled}
            showProgress={showProgress}
            isPickExpected={boxItems.some(
              (p) =>
                p.skuID === oi.skuID &&
                p.shelfNumber === oi.shelfNumber &&
                p.isRxItem === oi.isRxItem
            )}
            rxDisplayBubble={oi.rxDisplayBubble}
            rxVaruNummer={oi.rxVaruNummer}
            isRxMode={isRxMode}
            alwaysShowMissing={alwaysShowMissing}
            currentRXSortBoxID={currentRXSortBoxID}
            boxID={oi.boxID}
            isRxItem={oi.isRxItem}
            rxIsNarc={oi.rxIsNarc}
          />
        ))}
      </Card.Group>
    </div>
  );
};

export default BoxItemList;
